import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      border: "0px",
      borderBottom: "2px solid transparent",
      borderRadius: "0px",
      height: "48px",
      padding: "0px 6px",
      width: "max-content",
      "& .MuiSvgIcon-root": {
        borderRadius: "4px",
        color: `${Colors.GREY450}`,
        padding: "4px",
        // Width and height should be 18px but added 8px to balance the padding
        width: "26px",
        height: "26px",
      },
      "&:hover": {
        backgroundColor: "transparent",
        "& .MuiSvgIcon-root": {
          backgroundColor: `${Colors.GREY100}`,
          color: `${Colors.BLUE400}`,
        },
      },
      "&.Mui-selected": {
        backgroundColor: "transparent",
        borderBottom: `2px solid ${Colors.BLUE400}`,
        "& .MuiSvgIcon-root": {
          backgroundColor: `${Colors.GREY100}`,
          color: `${Colors.BLUE400}`,
        },
        "&:hover": {
          backgroundColor: "transparent",
          "& .MuiSvgIcon-root": {
            backgroundColor: `${Colors.GREY100}`,
            color: `${Colors.BLUE400}`,
          },
        },
      },
      "&.Mui-disabled": {
        border: "none",
        "& .MuiSvgIcon-root": {
          color: `${Colors.GREY350}`,
        },
      },
    },
  },
};
